import CopyButton from '../../CopyButton';

type Props = { uniqueId: string };

export const PointIdCopyControl = ({ uniqueId }: Props) => {
  return <CopyButton textToCopy={uniqueId} hoverText='Copy Point ID' />;
};
